import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import { CloseOutlined, FolderOutlined } from "@ant-design/icons";
import { useParams } from "react-router";

import { Uploader } from "../Uploader";
import { selectPatientDetails, selectPatientAttachmentsCount } from "../../store/selector";
import { Popover } from "../UI/Antd/Popover/Popover";
import { sizes } from "../../constant/styles";
import { getPopupPlacement } from "../../utils/patient";
import ACTIONS from "../../store/action";

const { Text } = Typography;

const PatientAttachmentsMenu = ({ onOpenConsentDrawer }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const patientDetails = useSelector(selectPatientDetails);
  const { patientId } = useParams();
  const count = useSelector(selectPatientAttachmentsCount);
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("bottomRight");

  useEffect(() => {
    if (patientId) {
      dispatch(ACTIONS.fetchPatientAttachmentsCountAction(patientId));
    }
  }, [patientId, dispatch]);

  const getAttachmentsCount = () => {
    dispatch(ACTIONS.fetchPatientAttachmentsCountAction(patientId));
  };

  const handleOpenChange = (visible) => {
    if (visible) {
      getPopupPlacement(setPlacement, "patient_attachments");
    }
    setVisible(visible);
  };

  return (
    <Popover
      trigger="click"
      placement={placement}
      id="patient_attachments_popover"
      open={visible}
      onOpenChange={handleOpenChange}
      title={
        <div>
          <Text style={{ fontSize: sizes.medium_large }} id="patient_name_attachments_popover">{`Attachments for ${
            patientDetails ? patientDetails.name : ""
          }`}</Text>
          <CloseOutlined id="close_patient_attachments_popover" onClick={() => setVisible(false)} />
        </div>
      }
      content={
        <Uploader
          getAttachmentsCount={getAttachmentsCount}
          showTopLogo={false}
          formStyle={{ border: "none", boxShadow: "none", width: "100%" }}
          wrapperStyle={{ width: "100%" }}
          isModalMode={false}
          onCloseAttachments={() => setVisible(false)}
          onOpenConsentDrawer={onOpenConsentDrawer}
        />
      }
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      <div
        id="patient_attachments"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}
      >
        <FolderOutlined style={{ fontSize: 16, paddingRight: 3 }} />
        <Text>{`${t("patientRSActions.attachments")}${count ? `(${count})` : ""}`}</Text>
      </div>
    </Popover>
  );
};

export const Attachments = PatientAttachmentsMenu;
